import React from 'react';

import { UiKit } from 'components';
import { RadioContext } from '../context';
import { useId } from 'utils/hooks';

/**
 * @param {Object} props
 * @param {string} props.name
 * @param {string} props.label
 * @param {string} props.tooltipText
 * @param {string} props.error
 * @param {string | null} props.value
 * @param {(value: string) => void} props.onChange
 * @param {"stack" | "inline"} props.variant
 * @param {boolean} props.disabled
 * @param {string} props.className
 * @param {import('utils/types').Space} props.gap
 * @param {React.ReactNode} props.children
 */
export default function RadioGroup({
  name = '',
  label = '',
  tooltipText = '',
  error = '',
  value = '',
  onChange = () => {},
  variant = 'stack',
  disabled = false,
  className = '',
  children = null,
  gap = undefined
}) {
  const fallbackName = useId('radio-name');

  return (
    <RadioContext.Provider
      value={{
        name: name || fallbackName,
        value,
        onChange,
        disabled
      }}
    >
      <UiKit.Group
        variant={variant}
        label={label}
        tooltipText={tooltipText}
        error={error}
        disabled={disabled}
        className={className}
        gap={gap}
      >
        {children}
      </UiKit.Group>
    </RadioContext.Provider>
  );
}
